import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43f30530"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ShopHeader" }
const _hoisted_2 = { class: "avatar" }
const _hoisted_3 = { class: "right" }
const _hoisted_4 = { class: "up" }
const _hoisted_5 = { class: "tl" }
const _hoisted_6 = { class: "tousu" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"10px"} }, "举报", -1))
const _hoisted_8 = { class: "down" }
const _hoisted_9 = { class: "createbtn" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "btn-font" }, "生成海报", -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode("订阅品种")
const _hoisted_12 = { class: "tag" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("实名认证")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("企业认证")
const _hoisted_15 = { class: "body" }
const _hoisted_16 = { class: "btn" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" 分享海报 ")
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" 保存海报 ")
const _hoisted_19 = { class: "closeIcon" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VanImage = _resolveComponent("VanImage")!
  const _component_VanButton = _resolveComponent("VanButton")!
  const _component_VanTag = _resolveComponent("VanTag")!
  const _component_VanPopup = _resolveComponent("VanPopup")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_VanImage, {
        src: $setup.props.detail?.information?.avatarUrl,
        fit: "cover",
        width: "72",
        height: "72",
        round: ""
      }, null, 8, ["src"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, _toDisplayString($setup.props.detail?.information?.nickName), 1),
        _createElementVNode("span", _hoisted_6, [
          _createElementVNode("span", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.tousu()))
          }, [
            _createVNode(_component_VanImage, {
              src: require('@/assets/img/jubao.png'),
              alt: "图片",
              width: "1rem",
              height: "1rem"
            }, null, 8, ["src"]),
            _hoisted_7
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("span", null, _toDisplayString($setup.props.detail?.receiptAddress), 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_VanButton, {
          class: "add",
          size: "mini",
          icon: "add",
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.createPic()))
        }, {
          default: _withCtx(() => [
            _hoisted_10
          ]),
          _: 1
        }),
        _createVNode(_component_VanButton, {
          size: "mini",
          icon: "add",
          plain: "",
          round: "",
          style: {"color":"#33ac9c","margin-left":"20px"},
          onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.subscribe($props.detail.categoryId)))
        }, {
          default: _withCtx(() => [
            _hoisted_11
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode($setup["VipTag"], {
          year: $setup.props.detail?.information?.year,
          type: $setup.props.detail?.userCertification?.vipRank
        }, null, 8, ["year", "type"]),
        _withDirectives(_createVNode(_component_VanTag, {
          size: "small",
          style: {"width":"48px"},
          plain: "",
          type: "primary"
        }, {
          default: _withCtx(() => [
            _hoisted_13
          ]),
          _: 1
        }, 512), [
          [_vShow, $setup.props.detail?.userCertification?.hasIdCard]
        ]),
        _withDirectives(_createVNode(_component_VanTag, {
          size: "small",
          style: {"width":"48px"},
          plain: "",
          color: "#6775D2"
        }, {
          default: _withCtx(() => [
            _hoisted_14
          ]),
          _: 1
        }, 512), [
          [_vShow, $setup.props.detail?.userCertification?.hasBusinessLicense]
        ])
      ])
    ]),
    _createVNode(_component_VanPopup, {
      class: "shareDialog",
      show: $setup.isShowshare,
      "onUpdate:show": _cache[5] || (_cache[5] = ($event: any) => (($setup.isShowshare) = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_VanImage, {
            src: $setup.imageurl,
            width: "100%",
            height: "100%"
          }, null, 8, ["src"]),
          _createElementVNode("span", null, _toDisplayString($setup.imageurl), 1)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_VanButton, {
            round: "",
            style: {"color":"#33AC9C","margin-right":"10px","padding":"0 30px"},
            onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => ($setup.share()), ["stop"]))
          }, {
            default: _withCtx(() => [
              _hoisted_17
            ]),
            _: 1
          }),
          _createVNode(_component_VanButton, {
            round: "",
            style: {"color":"#33AC9C","padding":"0 30px"},
            onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => ($setup.save()), ["stop"]))
          }, {
            default: _withCtx(() => [
              _hoisted_18
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_VanImage, {
            src: require("@/assets/img/close.png"),
            onClick: $setup.close
          }, null, 8, ["src"])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_VanPopup, {
      class: "openDialog",
      show: $setup.isShowOpen,
      "onUpdate:show": _cache[6] || (_cache[6] = ($event: any) => (($setup.isShowOpen) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_VanImage, {
          src: "https://mdd-static.oss-cn-hangzhou.aliyuncs.com/wechat/h5/share.png",
          width: "100%"
        })
      ]),
      _: 1
    }, 8, ["show"])
  ], 512)), [
    [_vShow, $setup.props.detail]
  ])
}